// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge--SidebarBadge-AcademySetup-components__1f8sq"};